import { useQuery } from '@tanstack/react-query';
import { registrationKeys } from './registrationKeys';
import type { UserRegistrationIntentResponse } from '@/services/register.types';
import { fetchRegistrationIntent } from '@/services/register.service.ts';

const useRegistrationIntentQuery = ({
  esid,
  it,
}: {
  esid?: string;
  it?: string;
  mockStatus?: string | null;
  mockType?: string | null;
  mockError?: string | null;
}) => {
  return useQuery<UserRegistrationIntentResponse>({
    queryKey: registrationKeys.intent(esid, it),
    enabled: !!(esid || it),
    queryFn: async () => {
      return fetchRegistrationIntent({
        externalSubscriptionId: esid,
        registrationToken: it,
      });
    },
  });
};

export default useRegistrationIntentQuery;
